import moment from 'moment'

import config from 'config'

const { dateFormat: { api: apiDateFormat, client: clientDateFormat } } = config

export class InternalBankTransferFormModel {
  constructor(props = {}) {
    this.amount = props.amount || 0
    this.targetBankAccountId = props.targetBankAccountId || null
    this.description = props.description || ''
    this.date = props.date && (moment(props.date, [apiDateFormat, clientDateFormat]).format(apiDateFormat) || moment().format(apiDateFormat))
    this.fee = props.fee
    this.isSumUpBooking = !!props.isSumUpBooking
  }

  validate() {
    return this.amount !== 0
            && this.targetBankAccountId
            && !!this.description
            && !!this.date
  }
}

export default InternalBankTransferFormModel
